import { render } from "./SuraNavigation.vue?vue&type=template&id=083283f0&ts=true"
import script from "./SuraNavigation.vue?vue&type=script&lang=ts"
export * from "./SuraNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__